import { render, staticRenderFns } from "./ItemDGEditForm.vue?vue&type=template&id=4471f960&"
import script from "./ItemDGEditForm.vue?vue&type=script&lang=js&"
export * from "./ItemDGEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports